var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"config":_vm.editorConfig,"value":_vm.value,"editor-url":'https://cdn.ckeditor.com/4.15.0/full-all/ckeditor.js'},on:{"ready":_vm.onReady,"input":function (value) { return _vm.$emit('input', value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }